var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysicalSimulation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_60040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.4 47.76V132.01C169.99 131.99 169.57 131.96 169.16 131.96C129.49 131.96 89.8299 131.96 50.1599 131.96C49.7499 131.96 49.3299 131.95 48.9199 131.99C47.6499 132.14 46.7199 133.15 46.6899 134.39C46.6599 135.62 47.5399 136.73 48.7799 136.93C49.3199 137.02 49.8799 136.98 50.4299 136.98C90.4199 136.98 130.41 136.98 170.4 136.98V142.78C169.63 144.33 168.29 144.58 166.71 144.57C122.02 144.55 77.3399 144.55 32.6499 144.55C32.1399 144.55 31.6299 144.55 31.1399 144.48C29.9399 144.31 29.1499 143.55 29.0599 142.41C28.9299 140.64 29.0299 138.86 29.0299 137.02C29.4299 137 29.6999 136.98 29.9599 136.98C32.9999 136.98 36.0399 137.01 39.0699 136.96C40.5699 136.94 41.6399 135.8 41.6199 134.42C41.5999 133.08 40.5699 132.05 39.1299 131.97C38.2599 131.92 37.3799 131.95 36.5099 131.95C34.0399 131.95 31.5699 131.95 28.9999 131.95C28.9999 131.36 28.9999 130.96 28.9999 130.55C28.9999 103.48 28.9999 76.42 28.9999 49.35C28.9999 46.88 29.8199 46.07 32.3299 46.07C41.6699 46.07 51.0099 46.07 60.3599 46.07C60.8099 46.07 61.2599 46.11 61.8399 46.14V47.84C61.8399 58.15 61.7199 68.46 61.9199 78.77C61.9699 81.56 61.2999 83.21 58.6799 84.37C56.0699 85.53 53.6699 87.18 50.9099 88.78C51.3199 87.18 51.6599 85.9 51.9699 84.62C52.3799 82.96 51.6899 81.62 50.2399 81.24C48.8799 80.88 47.5899 81.68 47.1499 83.26C46.2299 86.53 45.3299 89.81 44.4899 93.11C44.0299 94.92 44.7299 96.08 46.5099 96.57C49.7899 97.47 53.0799 98.34 56.3699 99.19C57.9299 99.59 59.2899 98.85 59.6299 97.48C59.9899 96.05 59.2499 94.84 57.6699 94.35C56.3699 93.95 55.0499 93.62 53.5999 93.22C53.8299 93.01 53.9399 92.87 54.0899 92.78C57.2699 90.94 60.4399 89.07 63.6599 87.3C64.0799 87.07 64.8999 87.2 65.3599 87.47C75.6399 93.29 85.8899 99.17 96.1699 105C96.9699 105.45 97.2199 105.96 97.1999 106.85C97.1499 109.98 97.1799 113.11 97.1799 116.24C97.1799 116.8 97.1799 117.36 97.1799 117.93C97.0499 117.98 96.9099 118.04 96.7799 118.09C95.9399 117.18 95.1299 116.24 94.2599 115.36C92.9599 114.05 91.4499 113.95 90.3799 115.02C89.3099 116.09 89.4199 117.63 90.7099 118.92C92.9799 121.21 95.2499 123.49 97.5399 125.76C99.0299 127.23 100.36 127.24 101.84 125.77C104.13 123.51 106.41 121.23 108.67 118.94C109.95 117.64 110.07 116.1 109.01 115.04C107.94 113.96 106.43 114.08 105.12 115.35C104.22 116.23 103.33 117.12 102.2 118.25C102.2 113.97 102.18 110.07 102.23 106.17C102.23 105.84 102.65 105.39 102.99 105.2C113.39 99.22 123.81 93.26 134.24 87.35C134.65 87.12 135.4 87.13 135.83 87.35C137.54 88.24 139.19 89.25 140.86 90.22C142.48 91.16 144.09 92.09 145.95 93.17C144.2 93.66 142.74 94 141.32 94.47C140.03 94.9 139.42 96.17 139.74 97.46C140.04 98.68 141.34 99.6 142.59 99.28C146.15 98.38 149.7 97.42 153.23 96.41C154.57 96.03 155.27 94.98 154.95 93.66C154.07 90 153.09 86.36 152.04 82.74C151.67 81.46 150.22 80.89 149 81.28C147.76 81.68 147.02 82.9 147.28 84.21C147.4 84.84 147.6 85.46 147.76 86.08C147.96 86.88 148.15 87.68 148.41 88.74C144.97 86.76 141.85 84.91 138.67 83.16C137.78 82.67 137.5 82.11 137.5 81.11C137.54 69.93 137.52 58.74 137.52 47.55C137.52 47.1 137.52 46.66 137.52 46.13C138.11 46.1 138.56 46.07 139.01 46.07C148.31 46.07 157.6 46.1 166.9 46.04C168.43 46.04 169.57 46.45 170.37 47.75L170.4 47.76Z",
    fill: "url(#paint0_linear_121_60040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.77 170.12C68.3 169.78 67.59 169.54 67.4 169.08C67.05 168.25 66.77 167.27 66.88 166.4C67.02 165.33 67.94 164.72 69.05 164.59C69.55 164.53 70.06 164.55 70.57 164.55C89.99 164.55 109.41 164.55 128.83 164.55C129.24 164.55 129.66 164.55 130.07 164.57C131.43 164.65 132.32 165.35 132.64 166.66C132.97 167.99 132.43 168.99 131.3 169.7C131.08 169.84 130.85 169.98 130.63 170.12H68.77Z",
    fill: "url(#paint1_linear_121_60040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5601 46.0105C74.7001 43.0705 79.7201 40.1905 84.7401 37.3205C89.3701 34.6705 94.0101 32.0405 98.6301 29.3805C99.3101 28.9905 99.8601 28.8205 100.64 29.2705C110.16 34.7505 119.71 40.1905 129.25 45.6405C129.41 45.7305 129.55 45.8505 129.82 46.0305C129.49 46.2605 129.23 46.4905 128.94 46.6605C119.52 52.0505 110.11 57.4405 100.67 62.7905C100.22 63.0505 99.3901 63.1205 98.9601 62.8805C89.3201 57.4205 79.7101 51.9105 70.0901 46.4105C69.9701 46.3405 69.8801 46.2505 69.5801 46.0205L69.5601 46.0105Z",
    fill: "url(#paint2_linear_121_60040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.21 99.7301C102.21 89.1801 102.21 78.8801 102.24 68.5801C102.24 68.1801 102.54 67.5901 102.88 67.4001C112.64 61.7901 122.42 56.2301 132.2 50.6501C132.23 50.6301 132.29 50.6401 132.46 50.6201C132.49 51.0001 132.55 51.3801 132.55 51.7601C132.55 61.6001 132.55 71.4501 132.56 81.2901C132.56 82.0101 132.49 82.5401 131.73 82.9701C122.18 88.3901 112.65 93.8501 103.12 99.3001C102.89 99.4301 102.65 99.5301 102.22 99.7301H102.21Z",
    fill: "url(#paint3_linear_121_60040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.91 50.4404C71.49 53.0604 75.87 55.5604 80.26 58.0604C85.57 61.0904 90.88 64.1004 96.16 67.1804C96.62 67.4504 97.15 68.1004 97.15 68.5704C97.21 78.8704 97.19 89.1704 97.19 99.6804C96.74 99.4704 96.38 99.3404 96.05 99.1504C86.63 93.7804 77.22 88.3904 67.8 83.0304C67.14 82.6504 66.83 82.2504 66.83 81.4304C66.86 71.4004 66.85 61.3804 66.85 51.3504C66.85 51.1304 66.87 50.9004 66.9 50.4404H66.91Z",
    fill: "url(#paint4_linear_121_60040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.41 149.75C118.75 153.2 120.02 156.51 121.3 159.82H78.09C79.34 156.61 80.63 153.31 82.02 149.75H117.42H117.41Z",
    fill: "url(#paint5_linear_121_60040)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_60040",
    x1: 99.6965,
    y1: 46.04,
    x2: 99.6965,
    y2: 144.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_60040",
    x1: 99.7958,
    y1: 164.547,
    x2: 99.7958,
    y2: 170.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_60040",
    x1: 99.6901,
    y1: 29.002,
    x2: 99.6901,
    y2: 63.0277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_60040",
    x1: 117.385,
    y1: 50.6201,
    x2: 117.385,
    y2: 99.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_60040",
    x1: 82.0116,
    y1: 50.4404,
    x2: 82.0116,
    y2: 99.6804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_121_60040",
    x1: 99.695,
    y1: 149.75,
    x2: 99.695,
    y2: 159.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_60040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.4,
    height: 141.12,
    fill: "white",
    transform: "translate(29 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalSimulation);
export default __webpack_public_path__ + "static/media/Physical_Simulation.6068e4f524407d9c6bdabd2f99f39e25.svg";
export { ForwardRef as ReactComponent };